var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.75 8.5c1.025 0 1.904.617 2.29 1.5h2.21a1 1 0 1 1 0 2h-2.21a2.499 2.499 0 0 1-4.58 0H2.25a1 1 0 1 1 0-2h5.21a2.5 2.5 0 0 1 2.29-1.5m0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6.75 2.5c1.025 0 1.904.617 2.29 1.5h5.21a1 1 0 1 1 0 2H9.04a2.499 2.499 0 0 1-4.58 0H2.25a1 1 0 0 1 0-2h2.21a2.5 2.5 0 0 1 2.29-1.5m0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
    clipRule: "evenodd"
  })));
};
export default Svg16;